import styled, { css } from 'styled-components';
import { maxWidth, minWidth } from '@/assets/styles/mixins.css.js';
import vars from '@/assets/styles/vars';
import Container from './StyledContainer';

const Header = styled.header`
  position: relative;
  z-index: 4;
  top: 0;
  left: 0;
  width: 100%;

  // & ~ main {
  //   margin-top: 127px;
  // }
  ${maxWidth(vars.breakpoints.tablet)`
    position: fixed;
    z-index: 3;
    top: 0;
    left: 0;
    width: 100%;
    border-bottom: none;

    & + * {
      margin-top: 70px;
    }
  //   & ~ main {
  //   margin-top: 0;
  // }
  `}

  ${maxWidth(vars.breakpoints.mobile)`
    & + * {
      margin-top: 64px;
    }
  `}
`;

Header.Inner = styled.div`
  position: relative;
  z-index: 11;
  background: var(--color-light);
  ${maxWidth(vars.breakpoints.tablet)`
    background: var(--color-light);
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  `}
`;

Header.Container = styled(Container)`
  display: flex;
  align-items: center;
  padding: 3px 0;

  ${maxWidth(vars.breakpoints.xsDesktop)`
    padding-top: 5px;
    padding-bottom: 6px;
  `}
`;

Header.Logo = styled.div`
  margin-right: auto;
  ${maxWidth(vars.breakpoints.mobile)`
    margin-right: 0;
  `}

  img {
    width:280px;
    height:76px;
    ${maxWidth(vars.breakpoints.tablet)`
      position:static;
      width: 192px;
      height: 50px;
    `}
  }

  ${(props) =>
    props.scrolled &&
    css`
      img {
        width:237px;
        height:54px;
        position:fixed;
        top:2px;
        animation: 0.3s appear linear forwards;
         ${maxWidth(vars.breakpoints.tablet)`
          position:static;
          animation:none;
          width: 142px;
          height: 50px;
        `}
      }
    `}

    @keyframes appear{
      from{
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
`;

Header.Items = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;

  ${maxWidth(100)`
    gap: 15px;
  `}

  ${maxWidth(vars.breakpoints.tablet)`
    display: none;
  `}
`;
Header.Address = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #323232;
  cursor: default;
  &:hover {
    a{
     text-decoration:underline;
    }
  }

  ${maxWidth(vars.breakpoints.xsDesktop)`
    padding: 13px 18px;
    font-size: 13px;
  `}

  &::before {
    content: '';
    display: flex;
    width: 15px;
    height: 18px;
    background-image: url("data:image/svg+xml,%3Csvg width='15' height='18' viewBox='0 0 15 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.5 9.8C8.84619 9.8 9.9375 8.72548 9.9375 7.4C9.9375 6.07452 8.84619 5 7.5 5C6.15381 5 5.0625 6.07452 5.0625 7.4C5.0625 8.72548 6.15381 9.8 7.5 9.8Z' stroke='%23B69B64' stroke-linecap='round' stroke-linejoin='round' /%3E%3Cpath d='M7.5 17C10.75 13.8 14 10.9346 14 7.4C14 3.86538 11.0899 1 7.5 1C3.91015 1 1 3.86538 1 7.4C1 10.9346 4.25 13.8 7.5 17Z' stroke='%23B69B64' stroke-linecap='round' stroke-linejoin='round' /%3E%3C/svg%3E");
    background-repeat: no-repeat;
    bacground-size: 99% auto;
    background-position: center;
    flex-shrink: 0;
  }
`;

Header.Languages = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-left: 70px;
  flex-shrink: 0;
  ${maxWidth(vars.breakpoints.tablet)`
    margin-left: 0;
  `}
`;

Header.Icons = styled.div`
  display: none;
  ${maxWidth(vars.breakpoints.tablet)`
    display: flex;
    gap: 15px;
    aligh-items:center;
    margin: 0 40px 0 auto;
    flex-shrink: 0;
  `}
  ${maxWidth(vars.breakpoints.mobile)`
    margin: 0 auto;
  `}
`;

Header.Search = styled.a`
  display: none;
  ${maxWidth(vars.breakpoints.tablet)`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 23px;
    height: 23px;
    color: #b69b64;
  `}
`;

Header.Account = styled.a`
  display: none;
  ${maxWidth(vars.breakpoints.tablet)`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 19px;
    height: 19px;
    background-image: url("data:image/svg+xml,%3Csvg width='19' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.7508 5.25052C13.7508 7.5968 11.8466 9.50103 9.50027 9.50103C7.15399 9.50103 5.24976 7.5968 5.24976 5.25052C5.24976 2.90423 7.15399 1 9.50027 1C11.8466 1 13.7508 2.90423 13.7508 5.25052Z' stroke='%23B69B64' stroke-linecap='round' stroke-linejoin='round' /%3E%3Cpath d='M18.0021 18V18C18.0021 14.87 15.4647 12.3326 12.3347 12.3326H6.66736C3.53736 12.3326 1 14.87 1 18V18' stroke='%23B69B64' stroke-linecap='round' /%3E%3C/svg%3E");
    background-repeat:no-repeat;
    background-size: 100% 100%;
    background-position: center;
  `}
`;

Header.Dropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 24px;
  z-index: 1;
  width: 186px;
  padding: 18px 24px;
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.04);
  cursor: default;
  transform: translateY(12px);
  opacity: 0;
  visibility: hidden;
  transition: transform 0.3s ease-in, opacity 0.25s ease-in, visibility 0s 0.25s;

  ${Header.Item}:hover > & {
    opacity: 1;
    visibility: visible;
    transform: none;
    transition: transform 0.3s 0.15s ease-out, opacity 0.3s 0.15s ease-out, visibility 0s 0.15s;
  }

  ${maxWidth(vars.breakpoints.xsDesktop)`
    left: 18px;
    width: 180px;
    padding: 12px 20px;
  `}

  a {
    padding: 5px 0;
    transition: color 0.3s ease-out;

    &:hover {
      color: var(--color-decor);
    }
  }
`;

Header.Prop = styled.dl`
  display: flex;
  padding: 5px 0;

  dt {
    padding-right: 5px;
    margin-right: auto;
  }

  ${(props) =>
    props.current &&
    css`
      color: var(--color-decor);
      text-shadow: 0.5px 0 0 currentColor;
    `}
`;

Header.Toggle = styled.div`
  margin-right: 14px;

  ${minWidth(vars.breakpoints.tablet + 1)`
    display: none;
  `}
`;

export default Header;
